import styled from 'styled-components'

export const ProductListStyle = styled.div`
  max-width: 1024px;
  width: 100%;
  margin: 56px auto 120px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
`
